var lx = lx || {};
lx.catalog = lx.catalog || {};

lx.catalog.updateField = {
    field: null,
    recId: null,
    $element: null,
    value: null,
    label: null,
    item: {label: null, type: "T", classResp: "col-12"},
    itemId: "lxUpdateField",
    dialog: {id: "catUpdateField", maxWidth: "400px"}, //,title: lx.tran.get('UPDATE_FIELD') > causes err
    open: function (pField, pRecId, pThis, pValue) {
        this.field = pField;
        this.recId = pRecId;
        this.$element = $(pThis);
        if (pValue) this.value = pValue;
        else this.value = $(pThis).text();

        switch (this.field){
            case "MIN_QTY": this.item.label = lx.tran.get('MIN_REQUIRED'); //'Minimum Required';
                            this.item.type = 'N';
                            break;
            default: null;
        }
        this.dialog.html = lx.item.gen({id: this.itemId, item: this.item, data: {r:this.value}});// '<div><input id="lxUpdateField" value="'+ this.value +'" /><div>';
        this.dialog.html = '<div class="row">'+ this.dialog.html +'</div>';
        this.dialog.buttons = [ {label: lx.tran.get('APPLY_CHANGES'), js: "lx.catalog.updateField.submit()", class: "t-Button--primary"},
                                {label: lx.tran.get('CANCEL'), js: "lx.dialog.close(this)"}];
        if (!this.dialog.title) this.dialog.title = lx.tran.get('UPDATE_FIELD');
        lx.dialog.open(this.dialog);
    },
    submit: function (){
        this.value = lx.item.val({type: this.item.type, id: this.itemId});
        //lx.info.alert("submit: "+ this.value, function () { lx.catalog.updateField.submitCallback({"success":true, value:this.value }); } );
        apex.server.process("fieldUpdate", {
            x01: this.field,
            x02: this.recId,
            x03: this.value
        }, {
			dataType: "json",
			success: function (d) {
                lx.catalog.updateField.submitCallback(d);
            }
        });
    },
    submitCallback: function (d){
        var self = lx.catalog.updateField;

        apex.message.clearErrors();
        if (d.success){
            self.$element.text(d.value);
            lx.dialog.close(null, self.dialog.id);
        } else if (d.err) apex.message.showErrors([{ type: "error", location: ["page"], message: d.err, unsafe: false }]);
        else apex.message.showErrors([{ type: "error", location: ["page"], message: "Something went wrong!", unsafe: false }]);
    }
}

lx.catalog.itemTabs = function (pType, pThis) {
    $(".lxItemPreview .tab_content").hide();
    $(".lxpTab.is-active").removeClass("is-active");
	if (pType == 'D') {
		$(".lxItemPreview .description").show();
		$("#lxpTAB-desc").addClass("is-active");
	}
	else if (pType == 'S') {
		$(".lxItemPreview .specification").show();
		$("#lxpTAB-spec").addClass("is-active");
	}
	else if (pType == 'R') {
		$(".lxItemPreview .rm_rating_plug").show();
		$("#lxpTAB-rate").addClass("is-active");
	}
	else if (pType == 'A') {
		$(".lxItemPreview .attach").show();
		$("#lxpTAB-att").addClass("is-active");
	}
}